
import React from 'react';
import { useLanguage } from '@/contexts/LanguageContext';
import { Button } from '@/components/ui/button';
import { Globe, Check } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

interface LanguageSwitcherProps {
  variant?: 'default' | 'outline' | 'ghost' | 'link';
  size?: 'default' | 'sm';
}

const LanguageSwitcher: React.FC<LanguageSwitcherProps> = ({ 
  variant = 'outline',
  size = 'default'
}) => {
  const { language, setLanguage, t } = useLanguage();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button 
          variant={variant} 
          size={size} 
          className={`gap-1 ${language === 'zh' ? 'bg-red-50 text-red-800 hover:bg-red-100 border-red-300' : ''}`}
        >
          <Globe className={`h-4 w-4 ${language === 'zh' ? 'text-red-600' : ''}`} />
          <span className="hidden sm:inline">
            {language === 'zh' ? '中文' : 'English'}
          </span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem 
          onClick={() => setLanguage('en')}
          className={language === 'en' ? 'bg-gray-100 font-bold' : ''}
        >
          <span className="mr-2">English</span>
          {language === 'en' && <Check className="h-4 w-4 ml-auto" />}
        </DropdownMenuItem>
        <DropdownMenuItem 
          onClick={() => setLanguage('zh')}
          className={language === 'zh' ? 'bg-red-50 font-bold text-red-800' : ''}
        >
          <span className="mr-2">中文</span>
          {language === 'zh' && <Check className="h-4 w-4 ml-auto text-red-600" />}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default LanguageSwitcher;
